import { httpPost } from "../../../../../../../Utils/apis/apis";

export const ExecuteSqlSP = async (payload) => {
    const response = await httpPost('/SQLQuery/getDataFromMultipleSPs?chartSPs=false', payload)
    return response
};

export const parseToolbar = (json, templateId) => {
    try {
        if (!json) return false;
        let parsedJson = JSON.parse(json);
        return countTemplateIdOccurrences(parsedJson?.primary?.filters, templateId);
    }
    catch {
        return 0
    }
}

function countTemplateIdOccurrences(data, templateId) {
    let count = 0;
    data.forEach(obj => {
        if (obj.templateIds.includes(templateId)) {
            count += 1;
        }
    });
    return count;
}